var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
import { getProgram } from "../utils/getProgram.obj";
import { getSwapDataAccountFromPublicKey } from "../utils/getSwapDataAccountFromPublicKey.function";
import { SystemProgram, Transaction, } from "@solana/web3.js";
import { findOrCreateAta } from "../utils/findOrCreateAta.function";
import { swapDataConverter } from "../utils/swapDataConverter.function";
import { getCNFTOwner } from "../utils/getCNFTData.function";
export function createInitializeSwapInstructions(Data) {
    return __awaiter(this, void 0, void 0, function () {
        var program, swapIdentity, initInstruction, addInstructions, validateInstruction, txWithoutSigner_1, initTxs_1, tx, validateTx, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    program = Data.program ? Data.program : getProgram({ clusterOrUrl: Data.clusterOrUrl });
                    return [4 /*yield*/, swapDataConverter({
                            swapInfo: Data.swapInfo,
                            clusterOrUrl: Data.clusterOrUrl,
                            connection: program.provider.connection,
                        })];
                case 1:
                    swapIdentity = _a.sent();
                    swapIdentity.swapData.initializer = Data.signer;
                    console.log("swapData to initialize", swapIdentity);
                    console.log("swapData ", swapIdentity.swapData.items);
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 6, , 7]);
                    return [4 /*yield*/, getInitInitilizeInstruction({
                            program: program,
                            swapIdentity: swapIdentity,
                            signer: Data.signer,
                            // acceptedPayement: swapIdentity.swapData.acceptedPayement,
                        })];
                case 3:
                    initInstruction = _a.sent();
                    return [4 /*yield*/, getAddInitilizeInstructions({
                            program: program,
                            swapIdentity: swapIdentity,
                            signer: Data.signer,
                            clusterOrUrl: Data.clusterOrUrl,
                            validateOwnership: Data.validateOwnership,
                            validateOwnershipIgnore: Data.validateOwnershipIgnore,
                        })];
                case 4:
                    addInstructions = _a.sent();
                    return [4 /*yield*/, getValidateInitilizeInstruction({
                            program: program,
                            swapIdentity: swapIdentity,
                            signer: Data.signer,
                        })];
                case 5:
                    validateInstruction = _a.sent();
                    txWithoutSigner_1 = [];
                    initTxs_1 = {};
                    if (initInstruction) {
                        tx = {
                            tx: new Transaction().add(initInstruction),
                            // signers: [signer],
                        };
                        txWithoutSigner_1.push(tx);
                        initTxs_1.init = [tx];
                    }
                    else {
                        console.log("Init-Initialize swap skipped");
                    }
                    if (addInstructions.ix) {
                        initTxs_1.add = [];
                        addInstructions.ix.map(function (addInstruction) {
                            var _a;
                            var _b;
                            var tx = {
                                tx: (_a = new Transaction()).add.apply(_a, addInstruction),
                                // signers: [signer],
                            };
                            txWithoutSigner_1.push(tx);
                            (_b = initTxs_1.add) === null || _b === void 0 ? void 0 : _b.push(tx);
                        });
                    }
                    else {
                        console.log("Add-Instrutions was skipped");
                    }
                    validateTx = {
                        tx: new Transaction().add(validateInstruction),
                    };
                    txWithoutSigner_1.push(validateTx);
                    initTxs_1.validate = [validateTx];
                    return [2 /*return*/, {
                            // initializeData: {
                            swapIdentity: swapIdentity,
                            programId: program.programId,
                            txWithoutSigner: txWithoutSigner_1,
                            initTxs: initTxs_1,
                            warning: addInstructions.warning,
                            // },
                            // shouldError: addInstructions.shouldError,
                        }];
                case 6:
                    error_1 = _a.sent();
                    console.log("error init", error_1);
                    throw __assign({ blockchain: "solana", status: "error", message: error_1 }, swapIdentity);
                case 7: return [2 /*return*/];
            }
        });
    });
}
function getInitInitilizeInstruction(Data) {
    return __awaiter(this, void 0, void 0, function () {
        var initSwapData, balanceSda;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    initSwapData = {
                        initializer: Data.swapIdentity.swapData.initializer,
                        items: [],
                        nbItems: Data.swapIdentity.swapData.nbItems,
                        preSeed: Data.swapIdentity.swapData.preSeed,
                        status: Data.swapIdentity.swapData.status,
                        acceptedPayement: Data.swapIdentity.swapData.acceptedPayement,
                    };
                    return [4 /*yield*/, Data.program.provider.connection.getBalance(Data.swapIdentity.swapDataAccount_publicKey)];
                case 1:
                    balanceSda = _a.sent();
                    // console.log("balance SDA", balanceSda);
                    if (balanceSda === 0) {
                        return [2 /*return*/, Data.program.methods
                                .initInitialize(Data.swapIdentity.swapDataAccount_seed, initSwapData)
                                .accounts({
                                swapDataAccount: Data.swapIdentity.swapDataAccount_publicKey.toBase58(),
                                signer: Data.signer.toBase58(),
                                systemProgram: SystemProgram.programId.toBase58(),
                            })
                                .instruction()];
                    }
                    else {
                        // console.log("swap Account already initialized");
                        return [2 /*return*/, undefined];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
function getAddInitilizeInstructions(Data) {
    var _a, e_1, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var bcData, error_2, transactionInstructionBundle, chunkSize, returnData, index, chunkIx, _loop_1, _d, _e, _f, e_1_1, warning, index, element, nbItems;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    bcData = undefined;
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getSwapDataAccountFromPublicKey({
                            program: Data.program,
                            swapDataAccount_publicKey: Data.swapIdentity.swapDataAccount_publicKey,
                        })];
                case 2:
                    bcData = _g.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _g.sent();
                    return [3 /*break*/, 4];
                case 4:
                    transactionInstructionBundle = [];
                    chunkSize = 4;
                    returnData = [];
                    index = 0;
                    _g.label = 5;
                case 5:
                    if (!(index < Data.swapIdentity.swapData.items.length)) return [3 /*break*/, 20];
                    chunkIx = [];
                    _g.label = 6;
                case 6:
                    _g.trys.push([6, 12, 13, 18]);
                    _loop_1 = function () {
                        var item, alreadyExistItems, tokenAccount, balance, error_3, owner, _h, _j;
                        return __generator(this, function (_k) {
                            switch (_k.label) {
                                case 0:
                                    _c = _f.value;
                                    _d = false;
                                    _k.label = 1;
                                case 1:
                                    _k.trys.push([1, , 14, 15]);
                                    item = _c;
                                    alreadyExistItems = bcData === null || bcData === void 0 ? void 0 : bcData.items.filter(function (itemSDA) {
                                        return itemSDA.mint.equals(item.mint) &&
                                            itemSDA.owner.equals(item.owner) &&
                                            itemSDA.destinary.equals(item.destinary);
                                    });
                                    if (!((alreadyExistItems === null || alreadyExistItems === void 0 ? void 0 : alreadyExistItems.length) === 0 || !alreadyExistItems)) return [3 /*break*/, 13];
                                    if (!(!!!item.amount.isNeg() &&
                                        // !!!item.mint.equals(SystemProgram.programId) &&
                                        !!!item.isCompressed &&
                                        !!item.isNft)) return [3 /*break*/, 7];
                                    return [4 /*yield*/, findOrCreateAta({
                                            mint: item.mint,
                                            owner: item.owner,
                                            // connection: Data.program.provider.connection,
                                            clusterOrUrl: Data.clusterOrUrl,
                                            signer: Data.signer,
                                        })];
                                case 2:
                                    tokenAccount = _k.sent();
                                    if (!!!Data.validateOwnership) return [3 /*break*/, 6];
                                    console.log("check NFT/Token balance", "\nmint:", item.mint.toBase58(), "\nowner:", item.owner.toBase58(), 
                                    // "program:",
                                    // Data.program,
                                    // "\nsigner:",
                                    // Data.signer.toBase58(),
                                    "\nATA:", tokenAccount.mintAta.toBase58());
                                    _k.label = 3;
                                case 3:
                                    _k.trys.push([3, 5, , 6]);
                                    return [4 /*yield*/, Data.program.provider.connection.getTokenAccountBalance(tokenAccount.mintAta)];
                                case 4:
                                    balance = _k.sent();
                                    console.log("balance ", balance.value.uiAmount, " / ", item.amount.toNumber());
                                    // await delay(1000);
                                    if (!balance.value.uiAmount && balance.value.uiAmount !== 0) {
                                        returnData.push({
                                            e: "User: ".concat(item.owner.toBase58(), " \nMint: ").concat(item.mint.toBase58(), "\nATA: ").concat(tokenAccount.mintAta.toBase58(), " \nError: cannot retrieve the balance\n\n"),
                                            mint: item.mint,
                                        });
                                    }
                                    else if (balance.value.uiAmount < item.amount.toNumber()) {
                                        returnData.push({
                                            e: "User: ".concat(item.owner.toBase58(), " \nMint: ").concat(item.mint.toBase58(), "\nATA: ").concat(tokenAccount.mintAta.toBase58(), " \nError: not enough funds; found ").concat(balance.value.uiAmount, " / ").concat(item.amount.toNumber(), " NFT the user own\n\n"),
                                            mint: item.mint,
                                        });
                                    }
                                    return [3 /*break*/, 6];
                                case 5:
                                    error_3 = _k.sent();
                                    console.log("error in get ataBalance :\n", error_3);
                                    returnData.push({
                                        e: "User: ".concat(item.owner.toBase58(), " \nMint: ").concat(item.mint.toBase58(), "\nATA: ").concat(tokenAccount.mintAta.toBase58(), " \nError: Couldn't find the NFT owned by user \n\n"),
                                        mint: item.mint,
                                    });
                                    return [3 /*break*/, 6];
                                case 6:
                                    console.log("XXX - added NFT item with Mint ", item.mint.toBase58(), " from ", item.owner.toBase58(), " amount ", item.amount.toNumber(), " - XXX");
                                    return [3 /*break*/, 11];
                                case 7:
                                    if (!!!item.isCompressed) return [3 /*break*/, 10];
                                    if (!!!Data.validateOwnership) return [3 /*break*/, 9];
                                    return [4 /*yield*/, getCNFTOwner({
                                            tokenId: item.mint.toBase58(),
                                            Cluster: Data.clusterOrUrl.includes("mainnet")
                                                ? "mainnet-beta"
                                                : "devnet",
                                        })];
                                case 8:
                                    owner = _k.sent();
                                    console.log("XXX - added CNFT item with TokenId ", item.mint.toBase58(), " from ", item.owner.toBase58(), " amount ", item.amount.toNumber(), " - XXX");
                                    if (!item.owner.equals(owner)) {
                                        returnData.push({
                                            e: "User: ".concat(item.owner.toBase58(), " \nTokenId: ").concat(item.mint.toBase58(), " \nError: Couldn't find the cNFT owned by user, owner is ").concat(owner),
                                            mint: item.mint,
                                        });
                                    }
                                    _k.label = 9;
                                case 9: return [3 /*break*/, 11];
                                case 10:
                                    console.log("XXX - added payment Item from ", !!item.mint.equals(SystemProgram.programId) ? "" : item.mint.toBase58(), item.owner.toBase58(), " amount ", item.amount.toNumber(), " - XXX");
                                    _k.label = 11;
                                case 11:
                                    _j = (_h = chunkIx).push;
                                    return [4 /*yield*/, Data.program.methods
                                            .initializeAdd(Data.swapIdentity.swapDataAccount_seed, item)
                                            .accounts({
                                            swapDataAccount: Data.swapIdentity.swapDataAccount_publicKey.toBase58(),
                                            signer: Data.signer.toBase58(),
                                        })
                                            .instruction()];
                                case 12:
                                    _j.apply(_h, [_k.sent()]);
                                    _k.label = 13;
                                case 13: return [3 /*break*/, 15];
                                case 14:
                                    _d = true;
                                    return [7 /*endfinally*/];
                                case 15: return [2 /*return*/];
                            }
                        });
                    };
                    _d = true, _e = (e_1 = void 0, __asyncValues(Data.swapIdentity.swapData.items.slice(index, index + chunkSize)));
                    _g.label = 7;
                case 7: return [4 /*yield*/, _e.next()];
                case 8:
                    if (!(_f = _g.sent(), _a = _f.done, !_a)) return [3 /*break*/, 11];
                    return [5 /*yield**/, _loop_1()];
                case 9:
                    _g.sent();
                    _g.label = 10;
                case 10: return [3 /*break*/, 7];
                case 11: return [3 /*break*/, 18];
                case 12:
                    e_1_1 = _g.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 18];
                case 13:
                    _g.trys.push([13, , 16, 17]);
                    if (!(!_d && !_a && (_b = _e.return))) return [3 /*break*/, 15];
                    return [4 /*yield*/, _b.call(_e)];
                case 14:
                    _g.sent();
                    _g.label = 15;
                case 15: return [3 /*break*/, 17];
                case 16:
                    if (e_1) throw e_1.error;
                    return [7 /*endfinally*/];
                case 17: return [7 /*endfinally*/];
                case 18:
                    // returnData = await Promise.all(
                    //     Data.swapIdentity.swapData.items.slice(index, index + chunkSize).map(async (item) => {})
                    // );
                    if (chunkIx.length > 0)
                        transactionInstructionBundle.push(chunkIx);
                    _g.label = 19;
                case 19:
                    index += chunkSize;
                    return [3 /*break*/, 5];
                case 20:
                    warning = "";
                    if (!!Data.validateOwnership)
                        if (returnData.length > 0) {
                            for (index = 0; index < returnData.length; index++) {
                                element = returnData[index];
                                // if (element) {
                                // console.log("bools");
                                // console.log(Data.warningIsError);
                                // console.log(element.mint.toString());
                                // console.log(!Data.warningIsError?.includes(element.mint.toString()));
                                if (Data.validateOwnership === "error" &&
                                    (!Data.validateOwnershipIgnore || //!!Data.validateOwnershipIgnore &&
                                        !Data.validateOwnershipIgnore.includes(element.mint.toString())))
                                    throw element.e;
                                warning = String(warning).concat("\n\n  //  " + String(element.e));
                                // }
                            }
                        }
                    nbItems = 0;
                    transactionInstructionBundle.forEach(function (transactionInstructionArray) {
                        nbItems += transactionInstructionArray.length;
                    });
                    console.log("there is ", nbItems, " items to initialize");
                    if (nbItems > 0) {
                        return [2 /*return*/, {
                                ix: transactionInstructionBundle,
                                warning: warning,
                                // shouldError: Data.warningIsError?.length === 0,
                            }];
                    }
                    else {
                        return [2 /*return*/, {
                                ix: undefined,
                                warning: warning,
                                // shouldError: false
                            }];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
function getValidateInitilizeInstruction(Data) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, Data.program.methods
                    .validateInitialize(Data.swapIdentity.swapDataAccount_seed)
                    .accounts({
                    swapDataAccount: Data.swapIdentity.swapDataAccount_publicKey.toBase58(),
                    signer: Data.signer.toBase58(),
                })
                    .instruction()];
        });
    });
}
